import { HttpClient } from '@angular/common/http';
import { Data, Response, waitAndRetry } from '@dimandzhi/graphql';
import { GraphQL } from 'app/graphql';
import { environment as env } from 'environments/environment';
import { map } from 'rxjs';

type gqlType = GraphQL.Server;
const gqlType = GraphQL.Server;
const ModelName = gqlType.getModelName();
export class Servers extends gqlType.createServiceBaseConstructor() {
  testSSHConnection(addr: string, sshConfig: string, privateKey: string, fsPath: string) {
    addr = new URL(addr).hostname;
    const fieldName = 'testSSHConnection';
    return (this.http as HttpClient)
      .post<Response>(
        env.graphql,
        JSON.stringify({
          query: `
          query ${fieldName}($addr: String!, $sshConfig: String!, $privateKey: String!, $fsPath: String!) {
            ${ModelName} {
              ${fieldName}(
                addr: $addr
                sshConfig: $sshConfig
                privateKey: $privateKey
                fsPath: $fsPath
              )
            }
          }`,
          operationName: fieldName,
          variables: {
            addr: addr,
            sshConfig: sshConfig,
            privateKey: privateKey,
            fsPath: fsPath,
          },
        }),
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        },
      )
      .pipe(
        waitAndRetry,
        Data.fromResp,
        map((data) => data.get(gqlType, fieldName) as any as string),
      );
  }
}
